import { connect } from 'react-redux'
import Child from './child'
import { getChild } from '../../../../../../stores/children/children.selectors'
import {
  approveChild,
  declineChild,
  removeChild
} from '../../../../../../stores/children/children.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { id, me, meRequest }) => {
  const child = getChild(state, id)
  return {
    id,
    userId: !meRequest.pending && me.account && me.account.id,
    name: child.student_type.account.full_name,
    avatar: child.student_type.account.avatar,
    permission: child.permission
  }
}

const mapDispatchToProps = dispatch => ({
  onApprove: id => dispatch(approveChild(id)).catch(errorHandler),
  onDecline: id => dispatch(declineChild(id)).catch(errorHandler),
  onRemove: (studentId, parentId) =>
    dispatch(removeChild(studentId, parentId)).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Child)
)
